export const saveUrlEscalation = (url: string) => {
    const storage = {
        url: url,
    };
    localStorage.setItem('escalation-url', JSON.stringify(storage));
};

export const retrieveUrlEscalation = (): {
    url: string;
} => {
    const storage = localStorage.getItem('escalation-url') || '';
    return JSON.parse(storage);
};
